import {compile} from "vue/dist/vue.esm-bundler";

(function () {
    const templates = Array.from(document.querySelectorAll('script[type="text/x-template"]'));

    console.group("Vue templates compile check");

    for (let i = 0; i < templates.length; i++) {
        const t = templates[i];
        const id = t.getAttribute("id") || `(no-id-${i})`;
        const html = (t.innerHTML || "").trim();

        try {
            compile(html);
            console.log(`✅ OK: ${id}`);
        } catch (e) {
            console.error(`❌ FAIL: ${id}`);
            console.log("---- TEMPLATE START ----");
            console.log(html.slice(0, 3000));
            console.log("---- TEMPLATE END ----");
            console.error(e);
            break;
        }
    }

    console.groupEnd();
})();

window.addEventListener("error", (e) => {
    console.error("GLOBAL ERROR:", e.error || e.message);
});

window.addEventListener("unhandledrejection", (e) => {
    console.error("UNHANDLED PROMISE:", e.reason);
});

/**
 * This will track all the images and fonts for publishing.
 */
import {nextTick} from "vue";

import.meta.glob(["../images/**", "../fonts/**"]);

/**
 * Main vue bundler.
 */
import {createApp} from "vue/dist/vue.esm-bundler";

/**
 * Main root application registry.
 */
window.app = createApp({
    data() {
        return {};
    },

    mounted() {

        nextTick(() => {
            initFeaturedProductsSwiper();

            [".bestsellers-swiper",
                ".recently-viewed-swiper",
                ".mobileCategoriesSwiper",
                ".brands-mobile-swiper",].forEach(initAllSwipers);
            initBrandsSwiper();
            initReviewsSwiper(".reviews-swiper");

            nextTick(() => this.lazyImages());
        });
    },

    methods: {
        onSubmit() {
        },

        onInvalidSubmit() {
        },

        lazyImages() {
            const lazyImages = Array.from(document.querySelectorAll('img.lazy'));

            if (!('IntersectionObserver' in window)) {
                lazyImages.forEach(img => {
                    if (img?.dataset?.src) img.src = img.dataset.src;
                    img.classList.remove('lazy');
                });
                return;
            }

            const lazyImageObserver = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (!entry.isIntersecting) return;

                    const img = entry.target;
                    if (img?.dataset?.src) img.src = img.dataset.src;
                    img.classList.remove('lazy');

                    observer.unobserve(img);
                });
            });

            lazyImages.forEach(img => {
                if (img instanceof Element) {
                    lazyImageObserver.observe(img);
                }
            });
        },
    },
});
/**
 * Global plugins registration.
 */
import Axios from "./plugins/axios";
import Emitter from "./plugins/emitter";
import Shop from "./plugins/shop";
import VeeValidate from "./plugins/vee-validate";
import Flatpickr from "./plugins/flatpickr";

[
    Axios,
    Emitter,
    Shop,
    VeeValidate,
    Flatpickr,
].forEach((plugin) => app.use(plugin));

/**
 * Global directives.
 */
import Debounce from "./directives/debounce";

app.directive("debounce", Debounce);

// Swiper integration for promotions carousel
import Swiper, {Navigation, Pagination} from "swiper";
import "swiper/css";
import "swiper/css/navigation";

Swiper.use([Navigation, Pagination]);


function initReviewsSwiper(selector = '.reviews-swiper') {
    document.querySelectorAll(selector).forEach(el => {
        if (!el || el.swiper) return;

        const nextEl = el.querySelector(".swiper-button-next");
        const prevEl = el.querySelector(".swiper-button-prev");
        const paginationEl = el.querySelector(".swiper-pagination");

        new Swiper(el, {
            modules: [Navigation, Pagination],
            spaceBetween: 24,

            pagination: {
                el: paginationEl,
                clickable: true,
            },
            navigation: {
                nextEl,
                prevEl
            },
            breakpoints: {
                320: {
                    slidesPerView: 1.2,
                    spaceBetween: 16,
                },
                640: {
                    slidesPerView: 1.5,
                    spaceBetween: 16,
                },
                1024: {
                    slidesPerView: 2.5,
                    spaceBetween: 20,
                },
                1280: {
                    slidesPerView: 3.5,
                    spaceBetween: 24,
                },
                1920: {
                    slidesPerView: 3.5,
                    spaceBetween: 24,
                }
            },
        });
    });
}

function initAllSwipers(selector) {
    document.querySelectorAll(selector).forEach(el => {
        if (!el || el.swiper) return;

        const nextEl = el.querySelector(".swiper-button-next");
        const prevEl = el.querySelector(".swiper-button-prev");
        const paginationEl = el.querySelector(".swiper-pagination");

        const options = {
            modules: [Navigation, Pagination],
            slidesPerView: 1.5,
            initialSlide: 1,
            spaceBetween: 20,

            slidesOffsetBefore: 16,
            slidesOffsetAfter: 16,

            centeredSlides: true,
            centeredSlidesBounds: true,

            pagination: {
                el: paginationEl,
                clickable: true,
            },
            navigation: nextEl && prevEl ? {
                nextEl,
                prevEl
            } : {},
            breakpoints: {
                640: {
                    slidesPerView: 2.2,
                    spaceBetween: 16,
                    slidesOffsetBefore: 16,
                    slidesOffsetAfter: 16,
                    centeredSlides: true,
                    centeredSlidesBounds: true,
                },
                1024: {
                    slidesPerView: 3.4,
                    spaceBetween: 16,
                    slidesOffsetBefore: 16,
                    slidesOffsetAfter: 16,
                    centeredSlides: true,
                    centeredSlidesBounds: true,
                },
                1280: {
                    slidesPerView: 5.2,
                    spaceBetween: 20,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                    centeredSlides: true,
                    centeredSlidesBounds: true,
                },
            },
        };

        new Swiper(el, options);
    });
}
function initNewProductsSwiper(root = document) {
    const el = root.querySelector(".new-products-swiper");
    if (!el) return;

    const nextEl = el.querySelector(".swiper-button-next");
    const prevEl = el.querySelector(".swiper-button-prev");
    const paginationEl = el.querySelector(".swiper-pagination");

    const options = {
        modules: [Navigation, Pagination],
        slidesPerView: 1.5,
        initialSlide: 1,
        spaceBetween: 16,

        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,

        centeredSlides: true,
        centeredSlidesBounds: true,

        pagination: {
            el: paginationEl,
            clickable: true,
        },
        navigation: nextEl && prevEl ? {
            nextEl,
            prevEl
        } : {},
        breakpoints: {
            640: {
                slidesPerView: 2.2,
                spaceBetween: 16,
                slidesOffsetBefore: 16,
                slidesOffsetAfter: 16,
                centeredSlides: true,
                centeredSlidesBounds: true,
            },
            1024: {
                slidesPerView: 3.4,
                spaceBetween: 16,
                slidesOffsetBefore: 16,
                slidesOffsetAfter: 16,
                centeredSlides: true,
                centeredSlidesBounds: true,
            },
            1280: {
                slidesPerView: 5.2,
                spaceBetween: 16,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
                centeredSlides: true,
                centeredSlidesBounds: true,
            },
        },
    };

    if (el.swiper) {
        Object.assign(el.swiper.params, options);
        el.swiper.update();
        return;
    }

    new Swiper(el, options);
}

// wystaw globalnie
window.initNewProductsSwiper = initNewProductsSwiper;
window.initReviewsSwiper = initReviewsSwiper;

function initPromotionsSwiper(root = document) {
    const el = root.querySelector(".promotions-swiper");
    if (!el) return;

    const nextEl = el.querySelector(".swiper-button-next");
    const prevEl = el.querySelector(".swiper-button-prev");
    const paginationEl = el.querySelector(".swiper-pagination");

    const options = {
        modules: [Navigation, Pagination],
        slidesPerView: 1.5,
        initialSlide: 1,
        spaceBetween: 20,

        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,

        centeredSlides: true,
        centeredSlidesBounds: true,

        pagination: {
            el: paginationEl,
            clickable: true,
        },
        navigation: nextEl && prevEl ? {
            nextEl,
            prevEl
        } : {},
        breakpoints: {
            640: {
                slidesPerView: 2.2,
                spaceBetween: 16,
                slidesOffsetBefore: 16,
                slidesOffsetAfter: 16,
                centeredSlides: true,
                centeredSlidesBounds: true,
            },
            1024: {
                slidesPerView: 3.4,
                spaceBetween: 16,
                slidesOffsetBefore: 16,
                slidesOffsetAfter: 16,
                centeredSlides: true,
                centeredSlidesBounds: true,
            },
            1280: {
                slidesPerView: 5.2,
                spaceBetween: 20,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
                centeredSlides: true,
                centeredSlidesBounds: true,
            },
        },
    };

    if (el.swiper) {
        Object.assign(el.swiper.params, options);
        el.swiper.update();
        return;
    }

    new Swiper(el, options);
}

window.initPromotionsSwiper = initPromotionsSwiper;

function initBrandsSwiper() {
    const el = document.querySelector(".brands-swiper");
    if (!el) return;

    const nextEl = el.querySelector(".swiper-button-next");
    const prevEl = el.querySelector(".swiper-button-prev");
    const paginationEl = el.querySelector(".swiper-pagination");

    const options = {
        modules: [Navigation, Pagination],
        slidesPerView: 1.5,
        initialSlide: 1,
        spaceBetween: 20,

        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,

        centeredSlides: true,
        centeredSlidesBounds: true,

        pagination: {
            el: paginationEl,
            clickable: true,
        },
        navigation: nextEl && prevEl ? {
            nextEl,
            prevEl
        } : {},
        breakpoints: {
            640: {
                slidesPerView: 2.2,
                spaceBetween: 16,
                slidesOffsetBefore: 16,
                slidesOffsetAfter: 16,
                centeredSlides: true,
                centeredSlidesBounds: true,
            },
            1024: {
                slidesPerView: 3.4,
                spaceBetween: 16,
                slidesOffsetBefore: 16,
                slidesOffsetAfter: 16,
                centeredSlides: true,
                centeredSlidesBounds: true,
            },
            1280: {
                slidesPerView: 4.2,
                spaceBetween: 20,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
                centeredSlides: true,
                centeredSlidesBounds: true,
            },
        },
    };

    if (el.swiper) {
        Object.assign(el.swiper.params, options);
        el.swiper.update();
        return;
    }

    new Swiper(el, options);
}

window.initBrandsSwiper = initBrandsSwiper;



let featuredSwiper = null;

function initFeaturedProductsSwiper() {
    const el = document.querySelector(".featured-mobile-swiper");
    if (!el) return;

    const isMobile = window.innerWidth < 1180;

    if (isMobile && !featuredSwiper) {
        const paginationEl = el.querySelector(".swiper-pagination");

        featuredSwiper =
            new Swiper(el, {
                modules: [Pagination],

                slidesPerView: "auto",
                centeredSlides: true,
                spaceBetween: 16,
                initialSlide: 1,
                watchOverflow: true,

                pagination: {
                    el: paginationEl,
                    clickable: true,
                },
            });
    }

    if (!isMobile && featuredSwiper) {
        featuredSwiper.destroy(true, true);
        featuredSwiper = null;
    }
}

window.addEventListener("load", initFeaturedProductsSwiper);
window.addEventListener("resize", initFeaturedProductsSwiper);


export default app;
